import * as modelsGet from "../models/get";
import { getLabels } from "../api/labels";

var labels: modelsGet.ILabel[];

/**
 * Gibt alle Labels zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getLabelsAsync(reload: boolean = false): Promise<modelsGet.ILabel[]>
{
    if (labels == null || reload)
    {
        labels = await getLabels();
    }

    return labels;
}